<template>
    <div>
        <div class="row">
            <div class='col'>
                <Breadcrumb :items="breadcrumbItems"/>
            </div>
        </div>

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div class="row">
            <div class='col'>
                <GoBackButton/>
            </div>
        </div>

        <!--  purchase transactions   -->
        <template v-if="getPurchaseDetails['@type'] === 'Purchase'">
            <div class="row mt-4">
                <div class="col-12 col-sm-6">
                    <div class="row">
                        <div class="col-6 bold">
                            {{ $t('printView.totalSum') }}:
                        </div>
                        <div class="col-6">
                            {{ showCurrencyById(getPurchaseDetails.currency !== null ? getPurchaseDetails.currency.id : null, getPurchaseDetails.totalPrice) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 bold">
                            {{ $t('date') }}:
                        </div>
                        <div class="col-6">
                            {{ dateTimeFormat(getPurchaseDetails.createdAt) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 bold">
                            {{ $t('supplier.title') }}:
                        </div>
                        <div class="col-6">
                            {{ supplierName(getPurchaseDetails) }}
                        </div>
                    </div>

                </div>

                <div class="col-12 col-sm-6">
                    <div class="row">
                        <div class="col-6 bold">
                            {{ $t('payed') }}:
                        </div>
                        <div class="col-6">
                            {{ showCurrencyById(getPurchaseDetails.currency !== null ? getPurchaseDetails.currency.id : null, getPurchaseDetails.payedAmount) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 bold">
                            {{ $t('productPurchase.debtAmount') }}:
                        </div>
                        <div class="col-6">
                            {{ showCurrencyById(getPurchaseDetails.currency !== null ? getPurchaseDetails.currency.id : null, getPurchaseDetails.totalPrice - getPurchaseDetails.payedAmount) }}
                        </div>
                    </div>

                </div>
            </div>

            <div class="d-none d-sm-block row mt-5">
                <div class="col-12">
                    <table class="w-100">
                        <thead class="light-table">
                        <tr>
                            <td class="bold">{{ $t('product.title') }}</td>
                            <td class="bold">{{ $t('amount') }}</td>
                            <td class="bold">{{ $t('warehouse.title') }}</td>
                            <td class="bold">{{ $t('price') }}</td>
                            <td class="bold">{{ $t('sale.sum') }}</td>
                        </tr>
                        </thead>
                        <tbody v-for="(productPurchase, index) in getPurchaseDetails.productPurchases" :key="index">
                        <tr>
                            <td>
                                {{ productPurchase.product.name }}
                            </td>
                            <td>
                                {{ parseFloat(productPurchase.amount) }}
                            </td>
                            <td>
                                {{ productPurchase.warehouse.name }}
                            </td>
                            <td>
                                {{ showCurrencyById(productPurchase.currency.id, productPurchase.pricePerUnit) }}
                            </td>
                            <td>
                                {{ showCurrencyById(productPurchase.currency.id, productPurchase.totalPrice) }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <template
                        v-if="parseFloat(getPurchaseDetails.payedAmount) < parseFloat(getPurchaseDetails.totalPrice) && !getPurchaseDetails.isCanceled"
                    >
                        <div class="d-flex mt-4">
                            <div class="flex-fill padding">{{ $t('payDebt') }}</div>
                            <div class="flex-fill padding ml-4" style="font-weight: normal">
                                <input
                                    type="number"
                                    v-model.number="item.purchaseRePayedAmount"
                                    style="width: 100px"
                                    :max="getPurchaseDetails.totalPrice - getPurchaseDetails.payedAmount"
                                    :min="0"
                                />
                                <span class="ml-2" style="font-weight: normal">
                                {{ showCurrencySymbolById(getPurchaseDetails.currency !== null ? getPurchaseDetails.currency.id : null) }}
                            </span>
                            </div>
                        </div>
                        <SubmitRow
                            class="padding d-flex flex-row-reverse"
                            text="save"
                            @click.native="updatePayment('purchase')"
                            :is-disabled="
                                item.purchaseRePayedAmount === 0 ||
                                item.purchaseRePayedAmount === ''"
                            :is-loading="$root.showOverlay"
                        />
                    </template>
                    <template v-if="canPurchaseProducts() && !getPurchaseDetails.isCanceled">
                        <CreditOrPayed class="mt-4" :model-form="item" :do-action="changePaymentState"/>
                    </template>
                    <template v-if="!canPurchaseProducts() && getPurchaseDetails.isCanceled">
                        {{ $t(hasPayedOrNoText) }}
                    </template>
                </div>
            </div>

            <div class="row d-block d-sm-none mt-4">
                <table class="w-100">
                    <tbody class="border-bottom" v-for="(productPurchase, index) in getPurchaseDetails.productPurchases"
                           :key="index">
                    <tr>
                        <td class="pl-3 bold">{{ $t('product.title') }}</td>
                        <td>{{ productPurchase.product.name }}</td>
                    </tr>
                    <tr>
                        <td class="pl-3 bold">{{ $t('amount') }}</td>
                        <td> {{ parseFloat(productPurchase.amount) }}</td>
                    </tr>
                    <tr>
                        <td class="pl-3 bold">{{ $t('warehouse.title') }}</td>
                        <td>
                            {{ productPurchase.warehouse.name }}
                        </td>
                    </tr>
                    <tr>
                        <td class="pl-3 bold">{{ $t('price') }}</td>
                        <td>
                            {{ showCurrencyById(productPurchase.currency.id, productPurchase.pricePerUnit) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="pl-3 bold">{{ $t('sale.sum') }}</td>
                        <td>
                            {{ showCurrencyById(productPurchase.currency.id, productPurchase.totalPrice) }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <Row type="none" class="d-flex justify-content-between mt-4">
                <TextTag class="text-danger" v-if="getPurchaseDetails.isCanceled">
                    {{ $t('sale.transaction.canceled') }}
                </TextTag>

                <ButtonTag
                    :is-w100="false"
                    :type="'button'"
                    :variant="'danger'"
                    :size="'md'"
                    :do-action="setCancelled"
                    class="mt-4"
                    v-else
                >
                    {{ $t('sale.transaction.cancel') }}
                </ButtonTag>
            </Row>
        </template>

        <!--           product purchase transactions-->
        <template v-else>
            <div class="row" v-if="getProductPurchaseDetails.id !== null">
                <div class='col'>
                    <table class="table table-striped mt-3">
                        <tbody>
                        <tr>
                            <th scope="col" width="50%">#</th>
                            <td>{{ getProductPurchaseDetails.id }}</td>
                        </tr>
                        <tr>
                            <th scope="col">{{ $t('product.title') }}</th>
                            <td>{{ getProductPurchaseDetails.product.name }}</td>
                        </tr>
                        <tr>
                            <th scope="col">{{ $t('supplier.title') }}</th>
                            <td>{{ supplierName(getProductPurchaseDetails) }}</td>
                        </tr>
                        <tr>
                            <th scope="col">{{ $t('amount') }}</th>
                            <td>
                                {{ getProductPurchaseDetails.amount }}
                                {{ showUnitOfMeasure(getProductPurchaseDetails.product.unitOfMeasure) }}
                            </td>
                        </tr>
                        <tr>
                            <th scope="col" class="uppercase">
                                {{
                                    $t(
                                        'productPurchase.pricePerUnit',
                                        {name: showUnitOfMeasure(getProductPurchaseDetails.product.unitOfMeasure)}
                                    )
                                }}
                            </th>
                            <td>
                                {{
                                    showCurrencyById(
                                        getProductPurchaseDetails.currency.id, calculateAmountByBaseCurrency(getProductPurchaseDetails.pricePerUnit, getProductPurchaseDetails.product.sellingPriceCurrency.shortName, getProductPurchaseDetails.currency.shortName)
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <th scope="col">{{ $t('totalPrice') }}</th>
                            <td>
                                {{
                                    showCurrencyById(
                                        getProductPurchaseDetails.currency.id, calculateAmountByBaseCurrency(getProductPurchaseDetails.totalPrice, getProductPurchaseDetails.product.sellingPriceCurrency.shortName, getProductPurchaseDetails.currency.shortName)
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <th scope="col">{{ $t('payed') }}</th>
                            <td>
                                {{
                                    showCurrencyById(
                                        getProductPurchaseDetails.currency.id, calculateAmountByBaseCurrency(getProductPurchaseDetails.payedAmount, getProductPurchaseDetails.product.sellingPriceCurrency.shortName, getProductPurchaseDetails.currency.shortName)
                                    )
                                }}
                            </td>
                        </tr>
                        <tr v-if="getProductPurchaseDetails.totalPrice !== getProductPurchaseDetails.payedAmount">
                            <th scope="col">{{ $t('debtAmount') }}</th>
                            <td>
                                {{
                                    showCurrencyById(
                                        getProductPurchaseDetails.currency.id,
                                        getProductPurchaseDetails.totalPrice - getProductPurchaseDetails.payedAmount
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <th scope="col">{{ $t('createdAt') }}</th>
                            <td>{{ dateTimeFormat(getProductPurchaseDetails.createdAt) }}</td>
                        </tr>

                        </tbody>
                    </table>
                    <template
                        v-if="
                            !item.isPayed &&
                            getProductPurchaseDetails.payedAmount !== getProductPurchaseDetails.totalPrice "
                            >
                        <div class="d-flex">
                            <div class="flex-fill padding">{{ $t('payDebt') }}</div>
                            <div class="flex-fill padding ml-4" style="font-weight: normal">
                                <input
                                    type="number"
                                    v-model.number="item.rePayedAmount"
                                    :max="getProductPurchaseDetails.totalPrice - getProductPurchaseDetails.payedAmount"
                                    style="width: 100px"
                                    min="0"
                                />
                                <span class="ml-2" style="font-weight: normal">
                                {{ showCurrencySymbolById(getProductPurchaseDetails.currency.id) }}
                            </span>
                            </div>
                        </div>
                        <SubmitRow
                            class="padding d-flex flex-row-reverse"
                            text="save"
                            @click.native="updatePayment('productPurchase')"
                            :is-disabled="
                                    getProductPurchaseDetails.rePayedAmount === 0 ||
                                    getProductPurchaseDetails.rePayedAmount === ''"
                            :is-loading="$root.showOverlay"
                        />
                    </template>

                    <template v-if="canPurchaseProducts() && !getProductPurchaseDetails.isCancelled">
                        <CreditOrPayed :model-form="item" :do-action="changePaymentState"/>
                    </template>
                    <template v-if="!canPurchaseProducts() && getProductPurchaseDetails.isCancelled">
                        {{ $t(hasPayedOrNoText) }}
                    </template>
                </div>
            </div>

            <Row type="none" class="d-flex justify-content-between">
                <TextTag class="text-danger" v-if="getProductPurchaseDetails.isCancelled">
                    {{ $t('sale.transaction.canceled') }}
                </TextTag>

                <ButtonTag
                    :is-w100="false"
                    :type="'button'"
                    :variant="'danger'"
                    :size="'md'"
                    :do-action="setCancelled"
                    class="mt-4"
                    v-else
                >
                    {{ $t('sale.transaction.cancel') }}
                </ButtonTag>
            </Row>
        </template>

    </div>
</template>

<script>
import Breadcrumb from "../../components/html/Breadcrumb";
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import GoBackButton from "../../components/GoBackButton";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import CreditOrPayed from "../../components/CreditOrPayed";
import dateFormatting from "@/mixin/dateFormattingMixin";
import accessMixin from "@/mixin/accessMixin";
import SubmitRow from "../../components/SubmitRow";
import Row from "../../components/html/Row";
import TextTag from "../../components/html/TextTag";
import ButtonTag from "../../components/html/ButtonTag";
import Modal from "@/components/html/Modal";
import currencyRateMixin from "@/mixin/currencyRateMixin";

export default {
    name: "ProductPurchasesShow",
    mixins: [validatorMixin, currencyFormatMixin, dateFormatting, accessMixin, currencyRateMixin],
    computed: {
        ...mapGetters(['getProductPurchaseDetails', 'getPurchaseDetails']),
        hasPayedOrNoText() {
            return this.item.isPayed ? 'payed' : 'onCredit'
        },
    },
    watch: {
        'item.rePayedAmount': function (newVal, oldVal) {
            if (newVal > this.getProductPurchaseDetails.totalPrice - this.getProductPurchaseDetails.payedAmount) {
                this.item.rePayedAmount = oldVal
            }
        }
    },
    methods: {
        ...mapActions([
            'pushProductPurchaseMakePayed',
            'pushProductPurchaseMakeUnPayed',
            'pushProductPurchaseRePayed',
            'fetchProductPurchase',
            'setProductPurchaseCancelled',
            'fetchPurchase',
            'setProductPurchaseDetails',
            'pushPurchaseRePayed',
            'pushPurchaseMakePayed',
            'pushPurchaseMakeUnPayed',
            'setPurchaseCancelled',
        ]),
        setCancelled() {
            this.$root.showOverlay = true

            if (this.isPurchase) {
                this.setPurchaseCancelled(this.getPurchaseDetails.id)
                    .then(() => {
                        this.fetchPurchase(this.getPurchaseDetails.id)
                            .then(() => {
                                this.$root.showOverlay = false
                            })
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.setProductPurchaseCancelled(this.getProductPurchaseDetails.id)
                    .then(() => {
                        this.fetchProductPurchase(this.getProductPurchaseDetails.id)
                            .then(() => {
                                this.$root.showOverlay = false
                            })
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            }
        },
        isPayed() {
            return this.item.isPayed
        },
        updatePayment(purchaseType) {
            this.$root.showOverlay = true

            if (purchaseType === 'purchase') {
                this.updatePurchasePayment()
            } else {
                this.updateProductPurchasePayment()
            }
        },
        updatePurchasePayment() {
            this.isPurchase = true
            let amount = ((parseFloat(this.item.purchaseRePayedAmount)) + (parseFloat(this.getPurchaseDetails.payedAmount))).toString()

            if (parseFloat(amount) >= parseFloat(this.getPurchaseDetails.totalPrice)) {
                this.item.isPayed = true
                console.log(1)
            }
            // else if (parseFloat(amount) > parseFloat(this.getPurchaseDetails.totalPrice)) {
            //     console.log(this.getPurchaseDetails)
            //     this.modalText = this.$t('overPayed')
            //     this.$bvModal.show('modal_show')
            //     this.$root.showOverlay = false
            // }
            else {
                this.pushPurchaseRePayed({purchaseId: this.getPurchaseDetails.id, payedAmount: parseFloat(this.item.purchaseRePayedAmount)})
                    .then(() => {
                        this.$router.go(0)
                    })
            }
        },
        updateProductPurchasePayment() {
            this.isPurchase = false
            let amount = ((+this.item.rePayedAmount) + (+this.getProductPurchaseDetails.payedAmount)).toString()

            if (parseFloat(amount) === parseFloat(this.getProductPurchaseDetails.totalPrice)) {
                this.item.isPayed = true
            } else {
                this.pushProductPurchaseRePayed({id: this.getProductPurchaseDetails.id, payedAmount: amount})
                    .then(() => {
                        this.$router.go(0)
                    })
            }
        },
        supplierName(item) {
            if (item.supplier === null) {
                return ''
            }

            if (item.supplier.person === null) {
                return item.supplier.supplierCompany.name
            }

            return item.supplier.person.givenName + ' ' + item.supplier.person.familyName
        },
        changePaymentState(isPayedState) {
            this.item.isPayed = isPayedState
            this.$root.showOverlay = true

            if (this.isPurchase) {
                this.purchaseChangePaymentState(isPayedState)
            } else {
                this.productPurchaseChangePaymentState(isPayedState)
            }
        },
        productPurchaseChangePaymentState(isPayedState) {
            if (isPayedState) {
                this.pushProductPurchaseMakePayed(this.getProductPurchaseDetails.id)
                    .then(() => {
                        this.pushProductPurchaseRePayed({
                            id: this.getProductPurchaseDetails.id,
                            payedAmount: this.getProductPurchaseDetails.totalPrice
                        })
                            .then(() => {
                                this.$router.go(0)
                            })
                    })
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.pushProductPurchaseMakeUnPayed(this.getProductPurchaseDetails.id)
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            }
        },
        purchaseChangePaymentState(isPayedState) {
            if (isPayedState) {
                this.pushPurchaseMakePayed(this.getPurchaseDetails.id)
                    .then(() => {
                        this.pushPurchaseRePayed({
                            purchaseId: this.getPurchaseDetails.id,
                            payedAmount: parseInt(this.getPurchaseDetails.totalPrice)
                        })
                            .then(() => {
                                this.fetchPurchase(this.getPurchaseDetails.id)
                                    .then(() => {
                                        this.$router.go(0)
                                        this.$root.showOverlay = false
                                    })
                            })
                            .catch(() => {
                                this.fetchPurchase(this.getPurchaseDetails.id)
                                    .then(() => {
                                        this.$router.go(0)
                                        this.$root.showOverlay = false
                                    })
                            })
                    })
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.pushPurchaseMakeUnPayed(this.getPurchaseDetails.id)
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            }
        },
    },
    data() {
        return {
            modalText: '',
            classIsPayed: false,
            isPurchase: true,
            item: {
                isPayed: false,
                rePayedAmount: '',
                purchaseRePayedAmount: '',
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'transactions'},
            ],
        }
    },
    mounted() {
        this.$root.showOverlay = true

        if (this.getPurchaseDetails['@type'] === 'ProductPurchase') {
            this.setProductPurchaseDetails(this.getPurchaseDetails)
            this.item.isPayed = this.getProductPurchaseDetails.transaction !== null
            this.isPurchase = false
        }

        // if (this.getPurchaseDetails === undefined || this.getPurchaseDetails.id === undefined) {
            this.fetchPurchase(this.$route.params.id)
                .then(() => {
                    this.isPurchase = true
                    this.item.isPayed = this.getPurchaseDetails.transaction !== null
                })
                .catch((error) => {
                    if (error === 'Not Found') {
                        this.fetchProductPurchase(this.$route.params.id)
                            .then(() => {
                                this.item.isPayed = this.getProductPurchaseDetails.transaction !== null
                                this.isPurchase = false
                                this.$root.showOverlay = false
                            })
                    }
                })
        // }

        if (this.getPurchaseDetails['@type'] === "Purchase") {
            this.item.isPayed = this.getPurchaseDetails.transaction !== null
        }

        this.$root.showOverlay = false
    },
    components: {
        ButtonTag,
        TextTag,
        Row,
        CreditOrPayed,
        GoBackButton,
        SubmitRow,
        Breadcrumb,
        Modal
    },
}
</script>

<style scoped>
.uppercase:first-letter {
    text-transform: uppercase;
}

.padding {
    padding: 0.75rem;
    padding-top: 0;
    font-weight: bold;
}

table {
    border-collapse: collapse;
    border-radius: 10px;
    /*box-shadow: 0 10px 20px 5px rgba(0, 0, 0, .15);*/
}

table tbody td {
    border-bottom: 0.5px solid #c5c5c5;
}

.light-table {
    background-color: #f5f5f5;
}

.dark-table {
    background-color: #ddd;
    /*box-shadow: 0 2px 5px 1px rgba(0, 0, 0, .15);*/

}

.border-bottom {
    border-top: 10px solid #f5f5f5;
}

.bold {
    font-weight: 700;
}
</style>
